export const reportNotesTransferredTypes = {
  SET_REPORT_NOTES_TRANSFERRED_FILTERS: 'SET_REPORT_NOTES_TRANSFERRED_FILTERS',
};